import { useCallback, useState } from 'react';
import { buildValuesSchema } from '../schemas/parameters.schema';
import { toFieldErrors, type FieldErrors } from '../utils/formErrors';

export type ValuesRecord = Record<string, number | undefined>;

interface UseValuesFormParams {
	initialValues: ValuesRecord;
	max?: number;
	maxMessage?: string;
	onSubmit: (values: Record<string, number>) => Promise<boolean>;
	onClose: () => void;
}

export const useValuesForm = ({ initialValues, max, maxMessage, onSubmit, onClose }: UseValuesFormParams) => {
	const [values, setValues] = useState(initialValues);
	const [errors, setErrors] = useState<FieldErrors>({});

	const setValue = useCallback((key: string, value: number | undefined) => {
		setErrors((previous) => ({ ...previous, [key]: '' }));
		setValues((previous) => ({ ...previous, [key]: value }));
	}, []);

	const submit = async () => {
		const parsed = buildValuesSchema(max, maxMessage).safeParse(values);
		if (!parsed.success) {
			setErrors(toFieldErrors(parsed.error));
			return;
		}
		if (await onSubmit(parsed.data)) onClose();
	};

	return { values, errors, setValue, submit };
};
